import React from 'react';
import { ArrowLeft, Edit } from 'lucide-react';

const BookingHeader = ({ 
  onBack, 
  status, 
  statusColor, 
  statusText, 
  onUpdateStatus 
}) => {
  const isCompleted = status === 'completed';
  
  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 sm:gap-3">
      <button
        onClick={onBack}
        className="inline-flex items-center text-black hover:text-gray-600 transition-colors text-sm sm:text-base"
      >
        <ArrowLeft className="w-4 h-4 mr-2" />
        Back to Bookings
      </button>
      <div className="flex items-center gap-3">
        <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs sm:text-sm font-medium ${statusColor}`}>
          {statusText}
        </span>
        {!isCompleted && (
          <button
            onClick={onUpdateStatus}
            className="inline-flex items-center gap-1.5 px-3 py-1 bg-black text-white rounded-lg hover:bg-gray-900 transition-colors text-xs sm:text-sm font-medium"
          >
            <Edit className="w-3.5 h-3.5" />
            Cancel
          </button>
        )}
      </div>
    </div>
  );
};

export default BookingHeader;

